import { render, staticRenderFns } from "./XTelInput.vue?vue&type=template&id=143ac4c8&scoped=true&"
import script from "./XTelInput.vue?vue&type=script&lang=js&"
export * from "./XTelInput.vue?vue&type=script&lang=js&"
import style0 from "./XTelInput.vue?vue&type=style&index=0&id=143ac4c8&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ac4c8",
  null
  
)

export default component.exports